var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8119 1.62902C12.9731 0.790326 11.6132 0.790326 10.7745 1.62902L2.25963 10.1431C2.20127 10.2014 2.15914 10.2738 2.13714 10.3532L1.01742 14.3953C0.971367 14.561 1.01816 14.7385 1.13972 14.8602C1.26146 14.9818 1.43894 15.0286 1.60468 14.9827L5.64714 13.8629C5.72656 13.8409 5.7989 13.7988 5.85725 13.7404L14.3719 5.22614C15.2094 4.38689 15.2094 3.02827 14.3719 2.18902L13.8119 1.62902ZM3.29956 10.4533L10.2683 3.485L12.5158 5.73227L5.54684 12.7006L3.29956 10.4533ZM2.85063 11.3541L4.64618 13.1496L2.1625 13.8377L2.85063 11.3541ZM13.697 4.55131L13.1908 5.05743L10.9432 2.80998L11.4495 2.30385C11.9154 1.838 12.6709 1.838 13.1368 2.30385L13.697 2.86385C14.1622 3.33027 14.1622 4.08508 13.697 4.55131Z",
    fill: "#575BE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.ecdede3c249e92ac3533698490a33a4e.svg";
export { ForwardRef as ReactComponent };